export const CSS_KEY = 'css';
export const JSON_KEY = 'json';
export const EDITOR_MESSAGE_ERROR = {
  css: ['Your CSS style is incorrect. Please check your syntax and try again'],

  json: [
    'Please check your syntax and remove any trailing commas. All keys and strings must be enclosed in double quotes',
  ],
};
